import Vue from 'vue';
import Moment from 'moment-timezone';
import VueMoment from 'vue-moment';
// Moment languages
import 'moment/locale/fr';


// TODO change all moment usage by this.$moment
window.moment = Moment;

Vue.use(VueMoment, { moment: Moment });
